import React from 'react';
import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { PdfMultiMonthModel } from '../types';

const pdfStyles = StyleSheet.create({
  page: {
    paddingTop: 18,
    paddingBottom: 18,
    paddingHorizontal: 18,
    fontSize: 9,
    fontFamily: 'Helvetica'
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10
  },
  headerLeft: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  title: { fontSize: 14, fontWeight: 700 },
  subtitle: { fontSize: 10, color: '#555' },
  powered: { fontSize: 10, color: '#555' },
  grid: { borderWidth: 1, borderColor: '#222' },
  weekRow: { flexDirection: 'row' },
  dayHeaderRow: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottomWidth: 2,
    borderColor: '#222'
  },
  dayHeaderCell: {
    width: '14.285714%',
    borderRightWidth: 1,
    borderColor: '#222',
    padding: 6,
    alignItems: 'center'
  },
  dayHeaderCellLast: { borderRightWidth: 0 },
  dayHeaderText: { fontSize: 10, fontWeight: 700 },
  cell: {
    width: '14.285714%',
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#222',
    padding: 4,
    minHeight: 70
  },
  cellLast: { borderRightWidth: 0 },
  dayNumber: { fontSize: 10, fontWeight: 700, marginBottom: 3 },
  dayNumberDim: { color: '#999' },
  line: { fontSize: 8, marginBottom: 2 }
});

export const CallOutCalendarPdf = ({
  model
}: {
  model: PdfMultiMonthModel;
}) => {
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <Document>
      {model.months.map((monthModel, monthIdx) => (
        <Page
          key={monthIdx}
          size="LETTER"
          orientation="landscape"
          style={pdfStyles.page}
        >
          <View style={pdfStyles.header} wrap={false}>
            <View style={pdfStyles.headerLeft}>
              <Text style={pdfStyles.title}>HOC</Text>
            </View>
            <View style={{ alignItems: 'center' }}>
              <Text style={pdfStyles.title}>Call-Out Calendar</Text>
              <Text style={pdfStyles.subtitle}>{monthModel.monthLabel}</Text>
            </View>
            <Text style={pdfStyles.powered}>Powered by HOC</Text>
          </View>

          <View style={pdfStyles.grid}>
            <View style={pdfStyles.dayHeaderRow}>
              {dayNames.map((dayName, idx) => (
                <View
                  key={dayName}
                  style={[
                    pdfStyles.dayHeaderCell,
                    ...(idx === 6 ? [pdfStyles.dayHeaderCellLast] : [])
                  ]}
                >
                  <Text style={pdfStyles.dayHeaderText}>{dayName}</Text>
                </View>
              ))}
            </View>
            {monthModel.weekRows.map((week, wIdx) => (
              <View key={wIdx} style={pdfStyles.weekRow}>
                {week.map((cell, cIdx) => (
                  <View
                    key={cell.key}
                    style={[
                      pdfStyles.cell,
                      ...(cIdx === 6 ? [pdfStyles.cellLast] : [])
                    ]}
                  >
                    <Text
                      style={[
                        pdfStyles.dayNumber,
                        ...(!cell.inMonth ? [pdfStyles.dayNumberDim] : [])
                      ]}
                    >
                      {cell.dayNumber}
                    </Text>
                    {cell.lines.slice(0, 4).map((l, idx) => (
                      <Text
                        key={idx}
                        style={[
                          pdfStyles.line,
                          ...(l.color ? [{ color: l.color }] : [])
                        ]}
                      >
                        {l.text}
                      </Text>
                    ))}
                  </View>
                ))}
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
};
